export default {"src":"/_next/static/media/new-call-24.f6808fbc.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};